import { PayloadSDK } from '@payloadcms/sdk';
import { parseCookie } from 'cookie';
import { IncomingMessage } from 'http';

import { publicConfig } from '@public-config';

import type { Config } from '@/payload-types';

const sdk = new PayloadSDK<Config>({
    baseURL: publicConfig.urls.api,
    fetch: (input: URL | RequestInfo, options: RequestInit = {}) => {
        const headers = new Headers(options.headers);

        if (publicConfig.environmentLockAccess) {
            headers.append('environmentLockAccess', publicConfig.environmentLockAccess);
        }

        if (input instanceof Request) {
            if (input.headers) {
                Array.from(input.headers.entries()).forEach(([key, value]) => {
                    headers.append(key, value);
                });
            }

            return fetch(
                new Request(input, {
                    ...options,
                    headers,
                }),
            );
        }

        return fetch(input, {
            ...options,
            headers,
        });
    },
});

// Workspace hosts rebase `publicConfig.urls.api` to the current origin after this module has
// been evaluated (in _app.tsx), so the base URL must be read per request, not at construction.
Object.defineProperty(sdk, 'baseURL', { get: () => publicConfig.urls.api });

const authHeaders = (req?: IncomingMessage): Record<string, string> => {
    const token = req && parseCookie(req.headers.cookie || '')['dcide-jwt'];

    return token ? { Authorization: token } : {};
};

export { authHeaders, sdk as PayloadSDK };
